export const SURF_FORECAST_NAV = Object.freeze({
  id: 'surf-forecast', header: 'Surf Forecast', path: '/surf-forecast', label: [],
})

export const PRIMARY_NAV_LINKS = Object.freeze([
  { path: '/where-to-stay', header: 'Stay' },
  { path: '/eat-drink', header: 'Eat & Drink' },
  { path: '/beaches-surfing', header: 'Beaches' },
  SURF_FORECAST_NAV,
  { path: '/things-to-do', header: 'Things to Do' },
  { path: '/blog', header: 'Guides' },
  { path: '/explore', header: 'Places' },
])

export function navigationCurrent(asPath, href) {
  const clean = value => value.split(/[?#]/)[0].replace(/\/+$/, '') || '/'
  const path = clean(asPath), target = clean(href)
  if (path === target) return 'page'
  return target !== '/' && path.startsWith(`${target}/`) ? 'location' : undefined
}
